import * as React from "react";
import { ZAttrType } from "src/business/attribute";
import { AttrUserTypeKey } from "src/business/attribute/AttrUserType";
import { PageUrl } from "src/routes/PageUrl";

import {
  ManagementSpecCommonCard,
  ManagementSpecCommonCardStore,
} from "../../ManagementSpecCommon/ManagementSpecCommonCard";

const pageStore = new ManagementSpecCommonCardStore({
  specType: "values",
  newTitle: "Новая спецификация значений",
  attrFeatures: {
    availableTypes: new Set<ZAttrType>([
      "dateTime",
      "file",
      "number",
      "string",
      "strOption",
      "boolean",
    ]),
    // MDM2-953
    availableAttrTypes: new Set<AttrUserTypeKey>([
      "float",
      "int",
      "string",
      "selectList",
      "dateTime",
      "boolean",
    ]),
  },
  middleCrumb: { type: "AdminValueSpecs" },
});

export const ManagementValueSpecCard: React.FC = () => (
  <ManagementSpecCommonCard
    pageStore={pageStore}
    listUrl={PageUrl.managementValueSpecs}
    cardUrl={PageUrl.managementValueSpecCard}
  />
);
